module.exports = __webpack_public_path__ + "fonts/Anjoman-FaNum-CondensedLightItalic.696c2f9.eot";